import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { goBack } from 'react-router-redux'

import ServiceInstructions from './ServiceInstructions'
import { update as updateRecurrence } from '@src/redux/modules/recurrence'
import { update as updateService } from '@src/redux/modules/service'
import * as qs from 'utils/querystring'

let ServiceInstructionsContainer = reduxForm({
  form: 'ServiceInstructions'
})(ServiceInstructions)

const mapStateToProps = (state, ownProps) => {
  const initialValues = {
    specialInstructions: ''
  }

  const { bookingId, serviceTypeId } = qs.parse(ownProps.location.search)

  return {
    initialValues,
    bookingId,
    serviceTypeId
  }
}

const mapDispatchToProps = {
  updateRecurrence,
  updateService,
  goBack
}

ServiceInstructionsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceInstructionsContainer)

export default ServiceInstructionsContainer



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceInstructions/ServiceInstructionsContainer.js